import type { HTMLAttributes, ReactElement, ReactNode } from 'react'

import styles from './tag.module.scss'

/**
 * `warn` is the stale-data / needs-attention tone (the freshness badge past its
 * threshold, a retired group somebody is still assigned to), `danger` a real
 * failure, `info` a neutral fact, `ok` a healthy state.
 */
export type TagTone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info'

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  label: ReactNode
  tone?: TagTone
}

export const Tag = ({ label, tone = 'neutral', className, ...rest }: TagProps): ReactElement => (
  <span
    className={[styles.tag, styles[`tag--${tone}`], className ?? ''].filter(Boolean).join(' ')}
    {...rest}
  >
    {label}
  </span>
)
